import { APIPromise } from "../services/HttpService";
import { ApiDefinition } from "./ApiDefinition";
import {
  Dashboard,
  DashboardHistoryDto,
  DashboardPaginatedRequest,
  PaginatedResponse,
} from "./model/dashboard/Dashboard";

class DashboardApiDefinition extends ApiDefinition {
  constructor() {
    super("/dashboard");
  }

  async getAllDashboards(): APIPromise<Array<Dashboard>> {
    return this.get("infos");
  }

  async getDashboard(dashboardId: number): APIPromise<Dashboard> {
    return this.get(`${dashboardId}`);
  }

  async getDashboardHistory(
    request: DashboardPaginatedRequest
  ): APIPromise<PaginatedResponse<DashboardHistoryDto>> {
    return this.get(`${request.dashboardId}/history`, {
      params: { skip: request.skip, take: request.take },
    });
  }

  async getDashboardsInfos(dashboardsId: Array<number>): APIPromise<Array<Dashboard>> {
    return this.get(`infos`, { params: { id: dashboardsId } });
  }

  async updateDashboard(dashboard: Dashboard, allowOverwrite?: boolean): APIPromise<Dashboard> {
    return this.post(null, dashboard, { params: { allowOverwrite } });
  }
}

const DashboardApi = new DashboardApiDefinition();

export default DashboardApi;
